<!-- Image Viewer Panel on the Left - Outside drawer container -->
@if (showImageViewer) {
  <div class="image-viewer-panel" [class.with-ocr]="showOcrText" [style.right.px]="drawerWidth">
    <div class="image-viewer-header">
      <span class="image-viewer-title">{{ showOcrText ? 'Receipt Image & OCR Text' : 'Receipt Image' }}</span>
      <button mat-icon-button (click)="closeImageViewer()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="image-viewer-content">
      <div class="image-section">
        <img
          #receiptImage
          [src]="receipt?.receiptUrl"
          alt="Receipt Image"
          class="full-receipt-image"
          (load)="onImageLoad()">
      </div>
      @if (showOcrText) {
        <div class="ocr-overlay" #ocrPanel>
          <!-- <div class="ocr-header">
            <h3>OCR Text</h3>
            <button mat-icon-button (click)="copyOcrText()" title="Copy OCR text">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div> -->
          <div class="ocr-text-content">
            <pre class="ocr-text">{{ ocrText || 'No OCR text available' }}</pre>
          </div>
        </div>
      }
    </div>
  </div>
}

<mat-drawer-container autosize class="mat-typography drawer-container">
  <mat-drawer #drawer mode="over" position="end" class="drawer" [style.width.px]="drawerWidth">
    <div class="resize-handle"
         (mousedown)="onResizeStart($event)"
         title="Drag to resize">
    </div>
    @if (receipt) {
      <div class="flex-row top-panel">
        <div>
          <span class="title font1">Receipt Details</span>
        </div>
        <div class="text-right">
          <lib-button variant="icon" icon="close" (buttonClick)="drawer.toggle()" tooltip="Close"></lib-button>
        </div>
      </div>
      @if (docId) {
        <app-receipt-panel-details
          [docId]="docId"
          (receiptUpdated)="onReceiptUpdated($event)"
          (imageClicked)="openImageViewer()">
        </app-receipt-panel-details>
      }
    }
  </mat-drawer>
  <mat-drawer-content>
    <!-- This is the main content area - should be empty for overlay panels -->
  </mat-drawer-content>
</mat-drawer-container>
